import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter } from "@vds/modals";
import { Title } from "@vds/typography";
import { css } from "@emotion/react";
import { CustomSLButton, FlexRow, Spacer } from "../../components/core/utility";
import { Icon } from "@vds/icons";
import moment from "moment";
import { Input } from "@vds/inputs";
import { getReasons } from "../../services/C4S Decommission - Replacement/editVehicleWTA";

export const StyledModal = css`
  max-height: 99vmin;
  padding: 2rem 2rem 2rem 2rem;
  padding-right: 2px;
  border-radius: 0.5rem !important;
  height: auto;

  @media (max-width: 767px) {
    width: 560px !important;
    height: auto;
    min-height: 14.5rem;
    padding: 2rem 2rem 2rem 2rem;
    padding-right: 2px;
  }
  div[data-testid="modal-body"] {
    padding: 0px;
    div {
      ::-webkit-scrollbar {
        width: 5px;
        height: 5px;
      }
    }
  }
  & footer {
    padding: 0;
  }
`;

export const StyledDatePicker = css`
  .react-calendar {
    z-index: 5;
    position: fixed;
    margin-top: 0rem;
    @media screen and (min-width: 760px) {
      transform: translateY(-52%);
    }
  }
`;

export default function ViewDeliveryDateModal({ opened, setOpened, onContinue }) {
  const [deliveryDate, setDeliveryDate] = useState("");
  const [defaultDate, setDefaultDate] = useState("");
  const [reason, setReason] = useState("");
  const [showReason, setShowReason] = useState(false);
  const [reasonOptions, setReasonOptions] = useState([]);

  useEffect(() => {
    if (opened) {
      const defDate = getDefaultDate(true, 5);
      setDefaultDate(defDate);
      setDeliveryDate(defDate);
      setReason("");
      setShowReason(false);
      // Fetch reasons from API with key
      (async () => {
        try {
          const reasonsResponse = await getReasons("ATP_CHANGE_REASONS");
          if (reasonsResponse?.data) {
            const reasonsList = reasonsResponse.data.data.map((reason) => ({
              id: reason.id,
              value: reason.id,
              label: reason.description,
            }));
            setReasonOptions(reasonsList);
          }
        } catch (e) {
          setReasonOptions([]);
        }
      })();
    }
  }, [opened]);

  const handleDate = (e) => {
    const newDate = moment(e).format("MMMM D, yyyy");
    setDeliveryDate(newDate);
    if (newDate !== defaultDate) {
      setShowReason(true);
      setReason("");
    } else {
      setShowReason(false);
      setReason("");
    }
  };

  const getDefaultDate = (format = true, daysToAdd = 5) => {
    let startDate = new Date();
    let currentDay = new Date().getDay();
    if (currentDay === 0) daysToAdd++;
    if (currentDay + daysToAdd >= 6) {
      let workingDaysInaWeek = 5;
      let remainingWorkDays = daysToAdd - (workingDaysInaWeek - currentDay);
      daysToAdd += 2;
      if (remainingWorkDays > 5) {
        daysToAdd += 2 * Math.floor(remainingWorkDays / 5);
        if (remainingWorkDays % 5 === 0) daysToAdd -= 2;
      }
    }
    startDate.setDate(startDate.getDate() + daysToAdd);
    return format ? moment(startDate).format("MMMM D, yyyy") : moment(startDate);
  };

  const isContinueDisabled = !deliveryDate || (showReason && !reason);

  return (
    <Modal
      role="dialog"
      ariaLabel={
        <>
          <Title size="medium">Requested Delivery Date</Title>
        </>
      }
      hideCloseButton={false}
      opened={opened}
      disableOutsideClick
      css={StyledModal}
      closeButton={
        <FlexRow justifyContent="space-between" onClick={(event) => event.preventDefault()}>
          <div>
            <Title size="medium">Confirm Requested Delivery Date</Title>
          </div>
          <div data-testid="close-icon" onClick={() => setOpened(false)} style={{ marginRight: "1rem", marginTop: "0.3rem" }}>
            <Icon
              aria-label="close"
              alt="close-icon"
              role="img"
              name="close"
              size="medium"
              color="#000000"
              style={{ cursor: "pointer", outline: "none" }}
            />
          </div>
        </FlexRow>
      }
    >
      <ModalBody css={{ paddingLeft: "0", paddingRight: "0", marginTop: "0.5rem" }}>
        <Spacer top="1rem" />
        <Input
          type="calendar"
          label="Requested Delivery Date"
          aria-label="Requested Delivery Date"
          onChange={handleDate}
          format="MMMM D, yyyy"
          value={deliveryDate ? moment(deliveryDate).format("MMM D, yyyy") : ""}
          errorText={""}
          error={false}
          css={StyledDatePicker}
          minDate={moment().add(1, "days").toDate()}
          maxDate={moment().add(14, "days").toDate()}
        />
        {showReason && (
          <div style={{ marginTop: "1rem" }}>
            <label
              htmlFor="reason-select"
              style={{
                marginBottom: 4,
                display: "block",
                fontSize: "0.75rem",
                fontWeight: 400,
                lineHeight: "1rem",
                fontFamily: "Verizon-NHG-eTX, Helvetica, Ariel, sans-serif",
                color: "rgb(0, 0, 0)",
                margin: 0,
                textDecoration: "none",
              }}
            >
              Select Reason for Change
            </label>
            <select
              id="reason-select"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              style={{
                width: "100%",
                padding: "0.75rem",
                //borderRadius: 4,
                border: "1px solid #ccc",
                fontSize: "1rem",
                fontWeight: 400,
                lineHeight: "1.25rem",
                fontFamily: "Verizon-NHG-eTX, Helvetica, Ariel, sans-serif",
                color: "rgb(0, 0, 0)",
                margin: "5px 0px",
                textDecoration: "none",
              }}
            >
              <option
                value=""
                disabled
                style={{
                  fontSize: "0.75rem",
                  fontWeight: 400,
                  lineHeight: "1rem",
                  fontFamily: "Verizon-NHG-eTX, Helvetica, Ariel, sans-serif",
                  color: "rgb(0, 0, 0)",
                  margin: 0,
                  textDecoration: "none",
                }}
              >
                Select a reason
              </option>
              {reasonOptions.map((opt) => (
                <option
                  key={opt.id}
                  value={opt.value}
                  style={{
                    fontSize: "0.75rem",
                    fontWeight: 400,
                    lineHeight: "1rem",
                    fontFamily: "Verizon-NHG-eTX, Helvetica, Ariel, sans-serif",
                    color: "rgb(0, 0, 0)",
                    margin: 0,
                    textDecoration: "none",
                  }}
                >
                  {opt.label}
                </option>
              ))}
            </select>
          </div>
        )}
        <Spacer bottom="2rem" />
      </ModalBody>
      <ModalFooter>
        <div style={{ display: "flex", justifyContent: "flex-end", width: "100%", paddingRight: 0, marginRight: 0 }}>
          <CustomSLButton secondary aria-label="Cancel" role="button" onClick={() => setOpened(false)}>
            Cancel
          </CustomSLButton>
          <CustomSLButton
            aria-label="Continue"
            role="button"
            primary
            disabled={isContinueDisabled}
            onClick={() => onContinue?.(deliveryDate, reason)}
            style={{ marginRight: 0 }}
          >
            Continue
          </CustomSLButton>
        </div>
      </ModalFooter>
    </Modal>
  );
}
